import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
const PlayerBadgeModal = (props) => {
  const convertToPascalCase = (str) => {
    // Remove underscores and split the string into words
    const words = str.split("_");

    // Capitalize the first letter of each word
    const pascalCaseString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return pascalCaseString.replace(/_/g, " ");
  };
  return (
    <>
      <Modal
        show={props.showBadgeModal}
        onHide={props.handleBadgeClose}
        id="playermoreinfo"
        size="lg"
      >
        <Modal.Header>{convertToPascalCase(props.badgeType)}</Modal.Header>
        <Modal.Body>
          {props.badgeType === "collector" && (
            <>
              <div class="badge rounded-pill custom_color1">Collector</div>{" "}
              <span>Has scored a Fifty (50) in an inning!</span>
            </>
          )}
          {props.badgeType === "centurion" && (
            <>
              <div class="badge rounded-pill custom_color2">Centurion</div>{" "}
              <span>Has scored a Hundred (100) in an inning!</span>
            </>
          )}

          {props.badgeType === "double_ton" && (
            <>
              <div class="badge rounded-pill custom_color3">Double Ton</div>{" "}
              <span>Has scored a Double-Hundred (200) in an inning!</span>
            </>
          )}

          {props.badgeType === "taker" && (
            <>
              <div class="badge rounded-pill custom_color4">Taker</div>{" "}
              <span>Has picked 3-4 Wickets in an inning!</span>
            </>
          )}

          {props.badgeType === "fifer" && (
            <>
              <div class="badge rounded-pill custom_color5">Fifer</div>{" "}
              <span>Has picked 5-6 Wickets in an inning!</span>
            </>
          )}

          {props.badgeType === "magician" && (
            <>
              <div class="badge rounded-pill custom_color6">Magician</div>{" "}
              <span>Has picked 7+ Wickets in an inning!</span>
            </>
          )}

          {props.badgeType === "provider" && (
            <>
              <div class="badge rounded-pill custom_color7">Provider</div>{" "}
              <span>Has collected 100-249 Fantasy Points in an inning!</span>
            </>
          )}

          {props.badgeType === "dependable" && (
            <>
              <div class="badge rounded-pill custom_color8">Dependable</div>{" "}
              <span>Has collected 250-499 Fantasy Points in an inning!</span>
            </>
          )}
          {props.badgeType === "juggernaut" && (
            <>
              <div class="badge rounded-pill custom_color9">Juggernaut</div>{" "}
              <span>Has collected 500+ Fantasy Points in an inning!</span>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link className="border-btn" onClick={props.handleBadgeClose}>
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PlayerBadgeModal;
